<app-center-container
  [title]="title"
  [showClose]="true"
  (close)="onClose()">

  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
      <app-input-wrapper
        [control]="form.get('export_task_type')"
        label="{{ 'exportTaskType' | translate }}">
        <mat-select
          class="form_control"
          formControlName="export_task_type"
          disableOptionCentering
          panelClass="dropdown"
          name="export_task_type"
          aria-label="{{ 'exportTaskType' | translate }}">
          @for (ett of exportTaskTypes; track ett.value) {
            <mat-option [value]="ett.value">
              {{ ett.name }}
            </mat-option>
          }
        </mat-select>
      </app-input-wrapper>
      @if (form.get('export_task_type')?.value === 'PERIMETRY') {
        <app-input-wrapper
          [control]="form.get('test_strategy')"
          label="{{ 'testStrategy' | translate }}">
          <mat-select
            class="form_control"
            formControlName="test_strategy"
            disableOptionCentering
            panelClass="dropdown"
            name="test_strategy"
            aria-label="{{ 'testStrategy' | translate }}">
            @for (testStrategy of displayedTestStrategies; track testStrategy.value) {
              <mat-option [value]="testStrategy.value">
                {{ testStrategy.name }}
              </mat-option>
            }
          </mat-select>
        </app-input-wrapper>
      }
      @if (form.get('export_task_type')?.value === 'PERIMETRY') {
        <app-input-wrapper
          [control]="form.get('test_protocol')"
          label="{{ 'testProtocol' | translate }}">
          <mat-select
            class="form_control"
            formControlName="test_protocol"
            disableOptionCentering
            panelClass="dropdown"
            name="test_protocol"
            aria-label="{{ 'testProtocol' | translate }}">
            @for (testProtocol of displayedTestProtocols; track testProtocol.value) {
              <mat-option [value]="testProtocol.value">
                {{ testProtocol.name }}
              </mat-option>
            }
          </mat-select>
        </app-input-wrapper>
      }
      @if (form.get('export_task_type')?.value === 'PERIMETRY') {
        <app-input-wrapper
          [control]="form.get('device_type')"
          label="{{ 'deviceType' | translate }}">
          <mat-select
            class="form_control"
            formControlName="device_type"
            disableOptionCentering
            panelClass="dropdown"
            name="device_type"
            aria-label="{{ 'deviceType' | translate }}">
            @for (type of deviceTypes; track type.value) {
              <mat-option [value]="type.value">
                {{ type.name }}
              </mat-option>
            }
          </mat-select>
        </app-input-wrapper>
      }
      <app-input-wrapper
        [control]="form.get('start_date')"
        label="{{ 'startDate' | translate }}"
        identifier="start_date">
        <input
          class="form_control"
          [matDatepicker]="pickerStartDate"
          [datePickerFormat]="preferencesService.defaultDateFormat.serverValue"
          formControlName="start_date"
          name="start_date"
          id="start_date">
          <mat-datepicker-toggle matSuffix [for]="pickerStartDate" class="form_datepicker-icon">
          </mat-datepicker-toggle>
        </app-input-wrapper>
        <mat-datepicker #pickerStartDate></mat-datepicker>
        <app-input-wrapper
          [control]="form.get('end_date')"
          label="{{ 'endDate' | translate }}"
          identifier="end_date">
          <input
            class="form_control"
            [matDatepicker]="pickerEndDate"
            [datePickerFormat]="preferencesService.defaultDateFormat.serverValue"
            formControlName="end_date"
            name="end_date"
            id="end_date">
            <mat-datepicker-toggle matSuffix [for]="pickerEndDate" class="form_datepicker-icon">
            </mat-datepicker-toggle>
          </app-input-wrapper>
          <mat-datepicker #pickerEndDate></mat-datepicker>
          @if (form.get('export_task_type')?.value === 'PERIMETRY') {
            <app-input-wrapper
              [control]="form.get('include_deviations')">
              <input
                type="checkbox"
                class="checkbox_input"
                formControlName="include_deviations"
                name="include_deviations"
                id="include_deviations">
                <label
                  for="include_deviations"
                  class="checkbox_label">
                  {{ 'includeDeviations' | translate | titlecase }}
                </label>
              </app-input-wrapper>
            }
            <app-input-wrapper
              [control]="form.get('include_reports')">
              <input
                type="checkbox"
                class="checkbox_input"
                formControlName="include_reports"
                name="include_reports"
                id="include_reports">
                <label
                  for="include_reports"
                  class="checkbox_label">
                  {{ 'includeReports' | translate | titlecase }}
                </label>
              </app-input-wrapper>
              @if (form.get('export_task_type')?.value === 'FUNCTIONAL_VISION') {
                <app-input-wrapper
                  [control]="form.get('phase2_only')">
                  <input
                    type="checkbox"
                    class="checkbox_input"
                    formControlName="phase2_only"
                    name="phase2_only"
                    id="phase2_only">
                    <label
                      for="phase2_only"
                      class="checkbox_label">
                      {{ 'exportPhase2Only' | translate | titlecase }}
                    </label>
                  </app-input-wrapper>
                }
                <button
                  class="button button--primary form_button"
                  type="submit"
                  [disabled]="!form.valid || !form.dirty || isLoading">
                  <span class="regular">{{ 'done' | translate }}</span>
                </button>
              </form>
            }

          </app-center-container>

          @if (isLoading) {
            <app-loader></app-loader>
          }